import { DEFAULT_CARD_HEIGHT, CardLayout } from './Gantt.utils'
import { ARROW_STROKE_COLOR } from './GanttChart.styles'

const SOURCE_ARROW_BOTTOM_LEFT_OFFSET = 24

type GanttArrowProps = {
  id: string
  arrowHeadMarkerId: string
  originAnchor?: 'bottom-start' | 'bottom-center'
  source: CardLayout
  target: CardLayout
  sourceSpineX: number
  isEmphasized: boolean
}

const getShouldUseBottomStartX = ({
  originAnchor,
  shouldLeaveFromBottom
}: {
  originAnchor?: GanttArrowProps['originAnchor']
  shouldLeaveFromBottom: boolean
}) => {
  if (originAnchor === 'bottom-start') return true
  if (originAnchor === 'bottom-center') return false
  return shouldLeaveFromBottom
}

const GanttArrow = ({
  id,
  arrowHeadMarkerId,
  originAnchor,
  source,
  target,
  sourceSpineX,
  isEmphasized
}: GanttArrowProps) => {
  const sourceRight = source.left + source.width
  const sourceBottom = source.top + DEFAULT_CARD_HEIGHT
  const sourceCenterX = source.left + source.width / 2
  const targetCenterY = target.top + DEFAULT_CARD_HEIGHT / 2
  const isTargetBelowSource = target.top >= sourceBottom
  const doesTargetStartWithinSourceSpan = target.left < sourceRight
  const shouldLeaveFromBottom =
    isTargetBelowSource && doesTargetStartWithinSourceSpan

  const shouldUseBottomStartX = getShouldUseBottomStartX({
    originAnchor,
    shouldLeaveFromBottom
  })

  const x1 = shouldUseBottomStartX
    ? source.left + SOURCE_ARROW_BOTTOM_LEFT_OFFSET
    : sourceCenterX
  const y1 = sourceBottom
  const x2 = target.left
  const y2 = targetCenterY
  const targetRight = target.left + target.width
  const shouldUseSpineFallback = x1 >= target.left && x1 <= targetRight

  const pathDefinition = shouldUseSpineFallback
    ? `M ${x1} ${y1} L ${sourceSpineX} ${y1} L ${sourceSpineX} ${y2} L ${x2} ${y2}`
    : `M ${x1} ${y1} L ${x1} ${y2} L ${x2} ${y2}`

  return (
    <path
      d={pathDefinition}
      fill='none'
      stroke={ARROW_STROKE_COLOR}
      strokeWidth={isEmphasized ? 2 : 1.5}
      markerEnd={`url(#${arrowHeadMarkerId})`}
      data-testid={`gantt-arrow-${id}`}
    />
  )
}

export default GanttArrow
